import { useEffect, useState } from "react";
import zoomUtil from "./utilities/zoom";

export function getWindowDimensions() {
  
    zoomUtil();
    const zoom = parseFloat(document.body.style.zoom) || 1;
    const { innerWidth: width, innerHeight: height } = window;
    //console.log('zoom:', zoom);
    return {
      width: Math.round(width / zoom),
      height: Math.round(height / zoom)
    };
  }
  
export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
        //console.log('windowDimensions:', getWindowDimensions());
      }
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return windowDimensions;
  }